import request from '@/utils/request'

export function tbWfItemPlanSelectItem(data) { //选择课程查询 - 查询
    return request({
        method: 'get',
        url: '/tbWfItem/planSelectItem',
        params: data
    })
}

export function tbSysDictDefinitionQueryEnumList(data) { //数据字典数据集 - 查询
    return request({
        method: 'get',
        url: '/tbSysDictDefinition/queryEnumList',
        params: data
    })
}

export function tbSysDictDefinitionQueryConstantStrList(data) { //方案上传附件类型 - 查询
    return request({
        method: 'get',
        url: '/tbSysDictDefinition/queryConstantStrList',
        params: data
    })
}

export function tbSysProManQuery(data) { //方案管理 - 查询
    return request({
        method: 'get',
        url: 'tbWfPlan/query',
        params: data
    })
}

export function tbSysProManQueryById(data) { //方案管理 - 根据ID查询
    return request({
        method: 'get',
        url: 'tbWfPlan/query/'+data,
    })
}

export function tbSysProManAdd(data) { //方案管理 - 新增
    return request({
        method: 'post',
        url: 'tbWfPlan/add',
        data
    })
}

export function tbSysProManUpdate(data) { //方案管理 - 编辑
    return request({
        method: 'post',
        url: '',
        data
    })
}

export function tbSysProManDelete(data) { //方案管理 - 删除
    return request({
        method: 'get',
        url: 'tbWfPlan/delete/'+data,
        
    })
}

export function tbSysProManDetails(data) { //方案管理 - 查询历史
    return request({
        method: 'get',
        url: 'tbWfPlan/query/'+data,
        
    })
}

export function tbWfRecordUpDate(data) { //方案 填写专家意见
    return request({
        method: 'post',
        url: '/tbWfRecord/update/',
        data
    })
}

export function tbWfRecordSubmitWfAuditInfo(data) { //课程 提交---获取审核人信息
    return request({
        method: 'get',
        url: '/tbWfRecord/getSubmitWfAuditInfo/',
        params: data
    })
}


export function tbDeptTreeList(data) { //单位 树结构
    return request({
        method: 'get',
        url: '/tbDept/queryDeptTreeList',
        params: data
    })
}

export function tbDeptUserList(data) { //单位 人员列表
    return request({
        method: 'get',
        url: '/tbDept/userByDeptId',
        params: data
    })
}

export function tbDeptAdd(data) { //单位 树结构 增加
    return request({
        method: 'post',
        url: '/tbDept/add',
        data
    })
}

export function tbDeptUpdate(data) { //单位 树结构 编辑
    return request({
        method: 'post',
        url: '/tbDept/update',
        data
    })
}


export function tbDeptDelete(data) { //单位 树结构 删除
    return request({
        method: 'post',
        url: '/tbDept/delete',
        data
    })
}


